import { render, staticRenderFns } from "./SafeImg.vue?vue&type=template&id=7c9a33b5"
import script from "./SafeImg.vue?vue&type=script&lang=js"
export * from "./SafeImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports